import { useMemo, useState } from 'react';
import { useDegrees } from 'v4/lib/hooks/use-degrees';
import { CustomDropdown } from '../custom-dropdown';

export const DegreesDropdown = ({ ...props }) => {
  const [search, setSearch] = useState();

  const { data, createLoading, mutateAsync, isLoading } = useDegrees({
    search,
  });

  const degrees = useMemo(
    () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
    [data?.pages]
  );

  return (
    <CustomDropdown
      {...props}
      data={degrees}
      isLoading={isLoading}
      onSearch={(s) => setSearch(s)}
    />
  );
};
